export function toTitleCase(str: string): string {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
}

export const preventDefaults = (e: DragEvent) => {
  e.preventDefault();
  e.stopPropagation();
};
